import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { NbAuthService } from "@nebular/auth";
import { Router } from "@angular/router";
import { StorageService } from "../../../../shared/services/storage.service";

@Component({
  selector: 'ngx-reset-password',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'full-screen-reset-password'
  }
})
export class NgxResetPasswordComponent implements OnInit {
  @ViewChild('resetPasswordContainer', { static: true }) resetPasswordContainer: ElementRef;
  
  user: any = {
    email: '',
    code: '',
    password: '',
    confirmPassword: ''
  };
  
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  showMessages = {
    error: false,
    success: false
  };
  strategy = 'email';
  showPassword = false;
  showConfirmPassword = false;
  codeSent = false;

  constructor(
    private authService: NbAuthService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    // Remove qualquer layout padrão do Nebular
    this.removeNebularLayout();
    
    // Carregar email do localStorage (método seguro)
    this.loadResetPasswordEmail();
    
    this.cd.detectChanges();
  }

  ngAfterViewInit() {
    // Garante que o componente ocupe toda a tela
    this.ensureFullScreen();
  }

  removeNebularLayout() {
    // Remove classes e estilos padrão do Nebular
    const body = document.body;
    body.classList.add('custom-reset-password-layout');
    
    // Remove qualquer container padrão do Nebular
    const nebularContainers = document.querySelectorAll('.nb-auth, .auth-block, .auth-container');
    nebularContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.style.display = 'none';
      }
    });
  }

  ensureFullScreen() {
    // Garante que o componente ocupe toda a tela
    if (this.resetPasswordContainer) {
      const container = this.resetPasswordContainer.nativeElement;
      container.style.width = '100vw';
      container.style.height = '100vh';
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.zIndex = '9999';
    }
  }

  loadResetPasswordEmail() {
    console.log('Carregando email para reset de senha...');
    
    const resetPasswordEmail = this.storageService.getLocalItem('resetPasswordEmail');
    
    if (resetPasswordEmail) {
      this.user.email = resetPasswordEmail;
      console.log('Email carregado com sucesso para reset de senha');
    } else {
      console.log('Nenhum email encontrado para reset de senha');
      // Se não encontrar email, redirecionar para request-password
      setTimeout(() => {
        this.router.navigate(['/auth/request-password']);
      }, 2000);
    }
  }

  // Método para reenviar código
  resendCode(): void {
    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    this.authService.requestPassword(this.strategy, { email: this.user.email }).subscribe({
      next: (result: any) => {
        this.submitted = false;
        if (result.isSuccess()) {
          this.messages = ['Código reenviado com sucesso! Verifique seu e-mail.'];
          this.showMessages.success = true;
        } else {
          const originalErrors = result.getErrors();
          this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          this.showMessages.error = true;
        }
        this.cd.detectChanges();
      },
      error: (error) => {
        this.submitted = false;
        this.errors = ['Erro ao reenviar código. Tente novamente.'];
        this.showMessages.error = true;
        this.cd.detectChanges();
      }
    });
  }

  // Método para validar código e resetar senha
  resetPassword(): void {
    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    // Validações básicas
    if (this.user.code.length !== 6) {
      this.errors = ['O código deve ter exatamente 6 dígitos.'];
      this.showMessages.error = true;
      this.submitted = false;
      this.cd.detectChanges();
      return;
    }

    if (this.user.password !== this.user.confirmPassword) {
      this.errors = ['As senhas não coincidem.'];
      this.showMessages.error = true;
      this.submitted = false;
      this.cd.detectChanges();
      return;
    }

    if (this.user.password.length < 6) {
      this.errors = ['A senha deve ter pelo menos 6 caracteres.'];
      this.showMessages.error = true;
      this.submitted = false;
      this.cd.detectChanges();
      return;
    }

    // Aqui você chamaria o endpoint para validar o código e resetar a senha
    // Por enquanto, vou simular o sucesso
    setTimeout(() => {
      this.submitted = false;
      this.messages = ['Senha alterada com sucesso! Redirecionando para o login...'];
      this.showMessages.success = true;
      
      // Limpar email do localStorage por segurança
      this.storageService.removeLocalItem('resetPasswordEmail');
      
      // Redirecionar após alguns segundos
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 3000);
      
      this.cd.detectChanges();
    }, 2000);

    // Implementação real seria algo como:
    /*
    this.authService.resetPassword(this.strategy, {
      email: this.user.email,
      code: this.user.code,
      password: this.user.password
    }).subscribe({
      next: (result: any) => {
        this.submitted = false;
        if (result.isSuccess()) {
          this.messages = ['Senha alterada com sucesso! Redirecionando para o login...'];
          this.showMessages.success = true;
          
          setTimeout(() => {
            this.router.navigate(['/auth/login']);
          }, 3000);
        } else {
          const originalErrors = result.getErrors();
          this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          this.showMessages.error = true;
        }
        this.cd.detectChanges();
      },
      error: (error) => {
        this.submitted = false;
        this.errors = ['Erro ao resetar senha. Verifique o código e tente novamente.'];
        this.showMessages.error = true;
        this.cd.detectChanges();
      }
    });
    */
  }

  // Métodos para mostrar/ocultar senhas
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // Método para voltar ao request-password
  goBackToRequestPassword(): void {
    // Salvar email novamente antes de voltar
    this.storageService.setLocalItem('resetPasswordEmail', this.user.email);
    this.router.navigate(['/auth/request-password']);
  }

  // Método para voltar ao login
  goBackToLogin(): void {
    this.router.navigate(['/auth/login']);
  }

  /**
   * Traduz mensagens de erro do inglês para português
   */
  private translateErrorMessage(error: string): string {
    const errorTranslations: { [key: string]: string } = {
      'Invalid verification code': 'Código de verificação inválido',
      'Code expired': 'Código expirado',
      'Code already used': 'Código já foi utilizado',
      'Password is required': 'Senha é obrigatória',
      'Password too short': 'Senha muito curta',
      'Passwords do not match': 'As senhas não coincidem',
      'Email is required': 'E-mail é obrigatório',
      'Invalid email format': 'Formato de e-mail inválido',
      'User not found': 'Usuário não encontrado',
      'Account is locked': 'Conta está bloqueada',
      'Account is disabled': 'Conta está desabilitada',
      'Too many failed attempts': 'Muitas tentativas falharam',
      'Session expired': 'Sessão expirada',
      'Network error': 'Erro de conexão',
      'Server error': 'Erro do servidor'
    };

    // Procura por uma tradução exata
    if (errorTranslations[error]) {
      return errorTranslations[error];
    }

    // Procura por traduções parciais
    for (const [english, portuguese] of Object.entries(errorTranslations)) {
      if (error.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return error;
  }

  getConfigValue(key: string): any {
    return true;
  }
}
